import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconPlaySvg } from "./IconPlaySvg.mjs";
const IconPlay = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconPlaySvg, ...iconProps });
};
export {
  IconPlay
};
